import { render } from "./TickHotspot.vue?vue&type=template&id=3d38b06b&scoped=true&ts=true"
import script from "./TickHotspot.vue?vue&type=script&lang=ts"
export * from "./TickHotspot.vue?vue&type=script&lang=ts"

import "./TickHotspot.vue?vue&type=style&index=0&id=3d38b06b&scoped=true&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d38b06b"]])

export default __exports__